import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TicketToMoneyPipe} from "../../../../shared/pipes/ticket-to-money.pipe";
import {RouterLink} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {ImageWrapperComponent} from "../../../../shared/components/image-wrapper/image-wrapper.component";
import {TicketComponent} from "../../../../shared/components/ticket/tournament/ticket.component";
import {NgIf} from "@angular/common";
import {IconModule} from "../../../../../../shared/assets/icons/ts/icon.module";
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";

@Component({
  selector: 'app-service-item-card',
    templateUrl: './service-item-card.component.html',
    styleUrl: './service-item-card.component.scss',
    standalone: true,
    imports: [
        TicketToMoneyPipe,
        RouterLink,
        TranslateModule,
        ImageWrapperComponent,
        TicketComponent,
        NgIf,
        IconModule,
        CurrencyPipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceItemCardComponent implements OnInit {
    public costMin:any;
    public costMax:any;
  @Input() product: any;

  constructor() {
  }

  ngOnInit() {
      if (!this.product) {
          return
      }
      if (this.product.services && this.product.services.length){
          if (this.product.services.length == 1){
              this.costMin = this.product.services[0].price
          }else{
              this.costMin = this.product.services[0].price
              this.costMax = this.product.services[0].price
              for (let i = 1; i < this.product.services.length; i++) {
                  if (this.product.services[i].price > this.costMax){
                      this.costMax = this.product.services[i].price
                  }
                  if (this.product.services[i].price < this.costMin){
                      this.costMin = this.product.services[i].price
                  }

              }
          }
      }
  }
}
